<div
  class="modal-backdrop"
  *ngIf="isOpen"
  (click)="handleBackdropClick($event)"
>
  <div
    class="modal-container"
    [ngClass]="config?.customClass || ''"
    (click)="$event.stopPropagation()"
  >
    <div class="modal-glow"></div>
    <!-- Header -->
    <div
      class="modal-header"
      *ngIf="config?.title || config?.showCloseButton !== false"
    >
      <h2 class="modal-title" *ngIf="config?.title">{{ config?.title }}</h2>
      <button
        class="close-btn"
        (click)="close()"
        *ngIf="config?.showCloseButton !== false"
      >
        <fa-icon [icon]="faXmark"></fa-icon>
      </button>
    </div>

    <!-- Body -->
    <div class="modal-body">
      <div class="modal-image" *ngIf="config?.image">
        <img [src]="config?.image" alt="Modal Image" />
      </div>
      <div
        class="modal-message"
        *ngIf="config?.message"
        [innerHTML]="config?.message"
      ></div>

      <!-- Custom Content Slot (Optional) -->
      <ng-content></ng-content>
    </div>

    <!-- Footer -->
    <div
      class="modal-footer"
      *ngIf="config?.buttons && (config?.buttons)!.length > 0"
    >
      <button
        *ngFor="let btn of config?.buttons"
        class="modal-btn"
        [ngClass]="btn.type || 'primary'"
        (click)="handleButtonClick(btn.action, btn.closeOnClick !== false)"
      >
        {{ btn.label }}
      </button>
    </div>
  </div>
</div>
